import KestrelOutline from 'assets/kestrel-outline.svg?react'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const StyledKestrel = styled(KestrelOutline)`
  width: 60px;
  height: 60px;
  position: relative;
  filter: blur(2px);
  transform: translateX(-8px);
`

const SpinnerOverlay = styled.div`
  position: absolute;
  top: 15%;
  left: 15%;
  width: 70%;
  height: 70%;
  border: 6px solid rgba(255, 255, 255, 0.1);
  border-top: 6px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const KestrelContainer = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
`

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

const LoadingText = styled.p`
  font-style: italic;
  opacity: 0.8;
  min-height: 1.2em;
`

const KestrelLoadingWidget: React.FC = () => {
  const loadingMessages = [
    'Loading vertices...',
    'Loading triangles...',
    'Putting it all together...',
    'Spreading wings...',
    'Loading textures...',
    'Preening feathers...',
    'Building the nest...',
    'Catching virtual mice...',
    'Adjusting flight patterns...',
    'Loading aerodynamics...',
    'Calculating wind speed...',
    'Sharpening talons...',
    'Setting up the scene...',
  ]

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => {
        let newIndex
        do {
          newIndex = Math.floor(Math.random() * loadingMessages.length)
        } while (newIndex === prevIndex)
        return newIndex
      })
    }, 3000)

    return () => clearInterval(intervalId)
  }, [loadingMessages.length])

  return (
    <Container>
      <KestrelContainer>
        <StyledKestrel />
        <SpinnerOverlay />
      </KestrelContainer>
      <LoadingText>{loadingMessages[currentMessageIndex]}</LoadingText>
    </Container>
  )
}

export default KestrelLoadingWidget
